import 'custom-event-polyfill';
import console from 'static/script/utils/console';
import $ from 'static/script/libs/jquery';
import 'static/script/utils/jquery-events';
import _ from 'static/script/libs/underscore';
import History from 'static/script/utils/history';
import FastClick from 'static/script/libs/fastclick';
import stacktrace from 'static/script/libs/stacktrace';
import bootLoadFonts from 'static/script/app/boot/boot-load-fonts';
import InitData from 'static/script/app/data/init-data';
import loadModules from './app/pages/load-modules';
import onReady from 'static/script/utils/on-ready';

export default new function () {
    window._ = window._ || _;
    window.$ = window.$ || $;
    window.printStackTrace = stacktrace;
    const initData = InitData.currentOrSet();

    if (!initData) {
        return;
    }

    if (window.addEventListener) {
        window.addEventListener('load', function () {
            if (initData.enableFastClick) {
                new FastClick(document.body);
            }
            bootLoadFonts();
        }, false);
    };

    onReady(() => {
        loadModules(initData);
    });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app.js